<h2>Select</h2>

This is a form component that allows the user to select an option from a list of options. The component can be configured:
<ul>
  <li>to display a search bar filtering the options</li>
  <li>to allow selecting multiple options (multiple mode)</li>
  <ul>
    <li>to have a "select all" option (in multiple mode)</li>
    <li>to manage selected options in a "cart" (in multiple mode)</li>
  </ul>
</ul>

<div class="gap-2">
  <p>Toggle the options and see the result below:</p>
  <vitamui-slide-toggle class="col" [(ngModel)]="enableSearch">Display search bar</vitamui-slide-toggle>
  <vitamui-slide-toggle class="col" [(ngModel)]="enableSelectAll">Display "select all" option (in multiple mode) </vitamui-slide-toggle>
  <vitamui-slide-toggle class="col" [(ngModel)]="enableDisplaySelected">Display "cart" (in multiple mode) </vitamui-slide-toggle>
</div>

@if (multiSelectOptions$ | async; as multiSelectOptions) {
  @for (config of configs; track config.name) {
    <h3>{{ config.name }}</h3>
    @for (entry of config.entries; track entry.type) {
      <div class="container-fluid p-0">
        <div class="row">
          @for (state of entry.states; track state.id) {
            <div class="col">
              <h4>{{ state.id + ' (' + entry.type + ')' }}</h4>
              <vitamui-select
                [attr.data-active]="state.id === 'Active'"
                [formControl]="state.control"
                [options]="multiSelectOptions"
                [placeholder]="'COMMON.ADRESS.COUNTRY' | translate"
                [searchBarPlaceHolder]="'INPUT.SEARCH_PLACEHOLDER' | translate"
                [multiple]="config.multiple"
                [enableSearch]="enableSearch"
                [enableSelectAll]="enableSelectAll"
                [enableDisplaySelected]="enableDisplaySelected"
                [errorMessageMap]="{
                  pattern: 'ERRORS.CONTAINS_GB',
                }"
              >
              </vitamui-select>
            </div>
          }
        </div>
      </div>
    }
  }

  <h3>Wrapper</h3>
  <p>The component is wrapped in another component that requires validating/cancelling the filled value before "emitting" it.</p>
  <vitamui-form-field-value-wrapper [formControl]="wrapperControl">
    <vitamui-select
      [placeholder]="'COMMON.ADRESS.COUNTRY' | translate"
      [options]="multiSelectOptions"
      [enableSearch]="false"
    ></vitamui-select>
  </vitamui-form-field-value-wrapper>
  <div><strong>Value: </strong>{{ wrapperControl.value | json }}</div>

  <h3>Loading</h3>
  <p>
    The component can show a loading spinner, for when options are not yes loaded, by providing an "options" of type ResourceRef (from
    Angular resource API).
  </p>
  <vitamui-select
    [placeholder]="'COMMON.ADRESS.COUNTRY' | translate"
    [options]="loadingOptions"
    [multiple]="true"
    [enableSearch]="enableSearch"
    [enableSelectAll]="enableSelectAll"
    [enableDisplaySelected]="enableDisplaySelected"
  ></vitamui-select>
}
